import { useState, useEffect, useRef } from 'react';
import { useQueryFilterDropdownState } from 'store/state';

export default function useComponentVisible<T extends HTMLElement>(
  initialIsVisible: boolean,
  disableAutoClose: boolean = false,
  domainKey?: string
) {
  const storeState = useQueryFilterDropdownState(domainKey || '');
  const [localIsVisible, setLocalIsVisible] = useState(initialIsVisible);

  const isComponentVisible = domainKey
    ? storeState.isOpen
    : localIsVisible;

  const ref = useRef<T>(null);

  const handleComponentVisible = () => {
    if (domainKey) {
      storeState.setDropdownState(!isComponentVisible);
    } else {
      setLocalIsVisible(prev => !prev);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(<Node>event!.target)) {
      if (domainKey) {
        storeState.setDropdownState(false);
      } else {
        setLocalIsVisible(false);
      }
    }
  };

  useEffect(() => {
    if (!disableAutoClose) {
      document.addEventListener('click', handleClickOutside, { capture: true });
      return () => {
        document.removeEventListener('click', handleClickOutside, {
          capture: true,
        });
      };
    }
  }, [disableAutoClose]);

  return { ref, isComponentVisible, handleComponentVisible };
}
